import { Request } from './../Shared/Request';
import { Form } from './../Shared/Form';
import { Analytics } from './../../modules/analytics';

export class Email extends Form {
    constructor(form, settings) {
        super(form, settings);
        this.request = new Request();

        document.getElementById('email-userID').addEventListener('blur', (event) => {
            this.setUserData('UserID', event.target.value);
        });

        document.getElementById('email-prefPhoneNumber').addEventListener('blur', (event) => {
            this.setUserData('PrefPhoneNumber', event.target.value.replace(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, '$1$2$3'));
        });

        if(typeof this.form.Computer_Serial !== 'undefined') {
            document.getElementById('email-Computer_Serial').addEventListener('blur', (event) => {
                this.setUserData('Computer_Serial', event.target.value);
            });
        }
    }

    send() {
        this.form.addEventListener('submit', (event) => {
            const success = document.getElementById('success');
            const down = document.getElementById('service-down');
            event.preventDefault();

            success.classList.add('core-u-hidden');
            down.classList.add('core-u-hidden');

            if (this.validation.invalids.length === 0) {
                let url = document.getElementById('emailUrl').value;
                const inputsArray   = this.setInputArray(
                    Array.from(this.form.querySelectorAll('input, textarea'))
                );
                const queryString   = this.serialize.data(
                    inputsArray
                );
                url     = url + "?" + queryString;

                const request = this.request.get(url);

                request.then((resp) => {
                    const response = JSON.parse(resp);
                    switch (response.statusCode) {
                        case 0:
                            this.form.reset();
                            success.classList.remove('core-u-hidden');
                            break;
                        case 2:
                        case 400:
                            down.classList.remove('core-u-hidden');
                            break;
                        default:
                    }
                });
                const analytics = new Analytics();
                analytics.trackEvent({'category':inputsArray['type'],'action':'click','label':'Send Email'});
            }

            return false;
        }, false);
    }
}



// WEBPACK FOOTER //
// ./src/modules/Email/index.js